import lib from "../index.js";

export const storageFactory = lib.storageFactory;
